/**
 * Copyright (c) 2021, Ouster, Inc.
 * All rights reserved.
 */
import { memo, useEffect } from 'react';

const KeyHandler = memo(
  (props: { keyDownHandler?: EventListener; keyUpHandler?: EventListener }) => {
    const { keyDownHandler, keyUpHandler } = props;

    // eslint-disable-next-line consistent-return
    useEffect(() => {
      if (keyDownHandler) {
        document.addEventListener('keydown', keyDownHandler);
        return () => {
          document.removeEventListener('keydown', keyDownHandler);
        };
      }
    }, [keyDownHandler]);

    // eslint-disable-next-line consistent-return
    useEffect(() => {
      if (keyUpHandler) {
        document.addEventListener('keyup', keyUpHandler);
        return () => {
          document.removeEventListener('keyup', keyUpHandler);
        };
      }
    }, [keyUpHandler]);

    return null;
  }
);

export { KeyHandler };
